/*eslint-disable*/
import React from 'react';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

// @material-ui/icons
import {
  Fingerprint,
  People,
  PersonAdd,
  PowerSettingsNew
} from '@material-ui/icons';

// core components
import Button from '../../components/CustomButtons/Button.jsx';
import history from '../../history.js';
import headerLinksStyle from '../../assets/jss/material-kit-react/components/headerLinksStyle.jsx';

class HeaderLinks extends React.Component {
  logout = () => {
    localStorage.clear();
    history.push({
      pathname: '/login'
    });
  };
  render() {
    const { classes } = this.props;
    return (
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Button
            href='http://employer-gvp-develop.s3-website.ap-south-1.amazonaws.com/auth/login'
            color='transparent'
            target='_blank'
            className={classes.navLink}
          >
            <Fingerprint className={classes.icons} /> LOGIN
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href='http://employer-gvp-develop.s3-website.ap-south-1.amazonaws.com/auth/register'
            color='transparent'
            target='_blank'
            className={classes.navLink}
          >
            <PersonAdd className={classes.icons} /> REGISTER
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href='http://www.capricetech.com/'
            color='transparent'
            target='_blank'
            className={classes.navLink}
          >
            <People className={classes.icons} /> CONTACT US
          </Button>
        </ListItem>
      </List>
    );
  }
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/custom-components/Header/HeaderLinks.jsx